/**
 * Caja de regalo en el cart-drawer (selector blanca / azul). v7.
 *
 * - La caja es un producto real. Linea extra con la propiedad oculta _caja_regalo.
 * - SIEMPRE caja S (blanca o azul). Las variantes M solo estan para poder retirarlas.
 * - SIEMPRE UNA SOLA CAJA, cantidad 1; las sobrantes se quitan solas.
 * - El selector solo sale si hay algun producto "elegible" (no muestras, ni regalos,
 *   ni los tipos de data-excluded-types). Sin productos elegibles NO hay caja.
 * - Mercados desactivados (data-enabled=false, p. ej. USA): sin selector y sin caja.
 *
 * RENDIMIENTO: sin peticion si el carrito ya esta bien; cambiar de color es UNA peticion;
 * no recarga el drawer al anadir la caja.
 *
 * CARRITO VACIO: si desaparecen los productos, la caja se retira y SOLO ENTONCES se avisa
 * al tema (si no, el tema cree que el carrito sigue lleno por la caja oculta y enseña
 * "Is it a gift?" y el pie con el carrito vacio). Como el tema no lanza evento al
 * quitar productos dentro del drawer, tambien se vigila el total en pantalla.
 */
(function () {
  'use strict';
  if (window.__carnerGiftBox) return;
  window.__carnerGiftBox = true;

  var ROOT_ID = 'carner-box-root';
  var debounceTimer = null;
  var busy = false;
  var queued = null;
  var lastFailSig = '';
  var lastCart = null;
  var selfEvent = false;
  var observed = [];
  var totalObserver = null;

  function getRoot() { return document.getElementById(ROOT_ID); }

  function readConfig() {
    var root = getRoot();
    if (!root) return null;
    function num(a) { return parseInt(root.getAttribute(a) || '0', 10) || 0; }
    var v = {
      white: { S: num('data-variant-white-s'), M: num('data-variant-white-m') },
      blue: { S: num('data-variant-blue-s'), M: num('data-variant-blue-m') }
    };
    return {
      enabled: root.getAttribute('data-enabled') === 'true',
      variants: v,
      boxIds: [v.white.S, v.white.M, v.blue.S, v.blue.M].filter(Boolean),
      excluded: (root.getAttribute('data-excluded-types') || '').toLowerCase().split(',')
        .map(function (s) { return s.trim(); }).filter(Boolean)
    };
  }

  function props(item) { return (item && item.properties) || {}; }
  function isTrue(v) { return v === true || v === 'true'; }

  function isBoxLine(item, cfg) {
    if (!item) return false;
    if (isTrue(props(item)._caja_regalo)) return true;
    return cfg.boxIds.indexOf(Number(item.variant_id)) !== -1;
  }
  function isSampleLine(item) { return isTrue(props(item).sample); }
  function isFreeGiftLine(item) {
    return (item.original_line_price || 0) > 0 && (item.final_line_price || 0) === 0;
  }
  function isEligibleLine(item, cfg) {
    if (!item || isBoxLine(item, cfg) || isSampleLine(item) || isFreeGiftLine(item)) return false;
    return cfg.excluded.indexOf(String(item.product_type || '').toLowerCase()) === -1;
  }
  function eligibleCount(cart, cfg) {
    var n = 0, items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (isEligibleLine(items[i], cfg)) n += Math.max(0, parseInt(items[i].quantity, 10) || 0);
    }
    return n;
  }
  function sizeFor(count) { return count < 1 ? null : 'S'; }

  function colorOfVariant(cfg, id) {
    id = Number(id);
    if (id === cfg.variants.blue.S || id === cfg.variants.blue.M) return 'blue';
    if (id === cfg.variants.white.S || id === cfg.variants.white.M) return 'white';
    return null;
  }
  function currentColor(cfg, boxLines) {
    for (var i = 0; i < boxLines.length; i++) {
      var c = colorOfVariant(cfg, boxLines[i].variant_id);
      if (c) return c;
    }
    return 'white';
  }
  function boxLinesOf(cart, cfg) {
    return (cart.items || []).filter(function (i) { return isBoxLine(i, cfg); });
  }

  function isUsableCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (typeof it.final_line_price !== 'number' || typeof it.original_line_price !== 'number') return false;
    }
    return true;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  /** Avisa al tema (solo cuando se retira la caja, para que repinte el carrito). */
  function announce(cart) {
    selfEvent = true;
    try {
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { detail: {}, bubbles: true }));
    } finally {
      selfEvent = false;
    }
  }

  function inSync(boxLines, target) {
    if (!target) return boxLines.length === 0;
    return boxLines.length === 1 && Number(boxLines[0].variant_id) === target && boxLines[0].quantity === 1;
  }

  /** Deja como maximo UNA linea de caja con cantidad 1. */
  function cleanupUpdates(boxLines, target) {
    var updates = {}, dirty = false, kept = false;
    boxLines.forEach(function (l) {
      if (Number(l.variant_id) !== target) { updates[l.key] = 0; dirty = true; }
      else if (!kept) {
        kept = true;
        if (l.quantity !== 1) { updates[l.key] = 1; dirty = true; }
      } else { updates[l.key] = 0; dirty = true; }
    });
    return { updates: updates, dirty: dirty };
  }

  async function enforceSingle(cfg, cart, target) {
    var lines = boxLinesOf(cart, cfg);
    if (inSync(lines, target)) return cart;
    var c = cleanupUpdates(lines, target);
    if (!c.dirty) return cart;
    var r = await post('/cart/update.js', { updates: c.updates });
    return r.ok ? await r.json() : await fetchCart();
  }

  /** Devuelve el carrito nuevo si ha cambiado algo, o null. */
  async function reconcile(cfg, cart, boxLines, target) {
    if (inSync(boxLines, target)) return null;

    var sig = cart.items.map(function (i) { return i.key + 'x' + i.quantity; }).join('|') + '>' + target;
    if (sig === lastFailSig) return null;

    var hasTarget = boxLines.some(function (l) { return Number(l.variant_id) === target; });

    // VIA RAPIDA: una peticion (anade la nueva por ID de variante y quita las viejas).
    var fast = cleanupUpdates(boxLines, target);
    if (target && !hasTarget) { fast.updates[String(target)] = 1; fast.dirty = true; }
    if (fast.dirty) {
      var r1 = await post('/cart/update.js', { updates: fast.updates });
      if (r1.ok) {
        var c1 = await r1.json();
        var present = !target || (c1.items || []).some(function (i) { return Number(i.variant_id) === target; });
        if (present) return await enforceSingle(cfg, c1, target);
        cart = c1;
        boxLines = boxLinesOf(c1, cfg);
        hasTarget = false;
      }
    }

    // VIA CLASICA: add.js y despues limpiar.
    var added = false;
    if (target && !hasTarget) {
      var res = await post('/cart/add.js', {
        items: [{ id: target, quantity: 1, properties: { _caja_regalo: 'true' } }]
      });
      if (!res.ok) {
        lastFailSig = sig;
        console.warn('Caja de regalo: no se pudo anadir la caja (estado ' + res.status + ')');
        return null;
      }
      added = true;
    }
    var slow = cleanupUpdates(boxLines, target);
    if (slow.dirty) {
      var r2 = await post('/cart/update.js', { updates: slow.updates });
      if (r2.ok) return await enforceSingle(cfg, await r2.json(), target);
      return await enforceSingle(cfg, await fetchCart(), target);
    }
    if (added) return await enforceSingle(cfg, await fetchCart(), target);
    return null;
  }

  function place(root) {
    var anchor = document.getElementById('CartNoteContainer');
    if (anchor && anchor.nextElementSibling !== root) anchor.insertAdjacentElement('afterend', root);
  }

  function hideBoxRows(cart, cfg) {
    if (!cart || !cfg) return;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      if (!isBoxLine(items[i], cfg)) continue;
      var links = document.querySelectorAll('[data-remove-key="' + items[i].key + '"]');
      for (var j = 0; j < links.length; j++) {
        var row = links[j].closest('[data-cart-item]');
        if (row && row.style.display !== 'none') row.style.display = 'none';
      }
    }
  }

  function markSelected(root, color) {
    var buttons = root.querySelectorAll('[data-carner-box-color]');
    for (var i = 0; i < buttons.length; i++) {
      var on = buttons[i].getAttribute('data-carner-box-color') === color;
      buttons[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      buttons[i].classList.toggle('is-selected', on);
    }
    var status = root.querySelector('[data-carner-box-status]');
    if (status) status.textContent = root.getAttribute('data-i18n-selected-' + color) || '';
  }

  function render(cart) {
    var root = getRoot();
    var cfg = readConfig();
    if (!root || !cfg || !cart) return;
    lastCart = cart;
    place(root);
    var show = cfg.enabled && eligibleCount(cart, cfg) > 0;
    if (root.hidden === show) root.hidden = !show;
    markSelected(root, currentColor(cfg, boxLinesOf(cart, cfg)));
    hideBoxRows(cart, cfg);
  }

  function plan(cfg, cart, overrideColor) {
    var boxLines = boxLinesOf(cart, cfg);
    var size = cfg.enabled ? sizeFor(eligibleCount(cart, cfg)) : null;
    var color = overrideColor || currentColor(cfg, boxLines);
    return { boxLines: boxLines, target: size ? cfg.variants[color][size] : 0 };
  }

  async function sync(cart, overrideColor) {
    if (busy) {
      queued = {
        cart: cart || (queued && queued.cart) || null,
        color: overrideColor || (queued && queued.color) || null
      };
      return;
    }
    var cfg = readConfig();
    if (!cfg) return;

    busy = true;
    try {
      var fromEvent = isUsableCart(cart);
      if (!fromEvent) cart = await fetchCart();

      var p = plan(cfg, cart, overrideColor);
      if (!inSync(p.boxLines, p.target) && fromEvent && !overrideColor) {
        cart = await fetchCart(); // confirmar con el carrito real antes de tocar nada
        p = plan(cfg, cart, overrideColor);
      }

      var hadBox = p.boxLines.length > 0;
      var fresh = await reconcile(cfg, cart, p.boxLines, p.target);
      render(fresh || cart);

      // Se ha retirado la caja (ya no hay productos que la lleven): el tema debe repintar.
      if (fresh && hadBox && !p.target && boxLinesOf(fresh, cfg).length === 0) announce(fresh);
    } catch (err) {
      console.error('Caja de regalo: error al sincronizar', err);
    } finally {
      busy = false;
      if (queued) {
        var q = queued;
        queued = null;
        sync(q.cart || lastCart, q.color);
      }
    }
  }

  function schedule(cart, delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { sync(cart || null, null); }, delay || 60);
  }

  document.addEventListener('theme:cart:change', function (e) {
    if (selfEvent) return;
    var cart = e && e.detail && (e.detail.cart || e.detail);
    schedule(isUsableCart(cart) ? cart : null);
    bindTotalObserver();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-carner-box-color]');
    if (!btn) return;
    e.preventDefault();
    var color = btn.getAttribute('data-carner-box-color');
    var root = getRoot();
    if (root) markSelected(root, color);
    sync(lastCart, color);
  });

  /** El tema no avisa al quitar productos dentro del drawer: se vigila el total. */
  function bindTotalObserver() {
    if (!window.MutationObserver) return;
    var els = document.querySelectorAll('[data-cart-final], [data-cart-subtotal]');
    var same = els.length === observed.length;
    for (var i = 0; same && i < els.length; i++) { if (els[i] !== observed[i]) same = false; }
    if (same) return;
    if (totalObserver) totalObserver.disconnect();
    observed = [];
    totalObserver = new MutationObserver(function () { schedule(null, 250); });
    for (var k = 0; k < els.length; k++) {
      observed.push(els[k]);
      totalObserver.observe(els[k], { childList: true, characterData: true, subtree: true });
    }
  }

  function init() {
    setTimeout(function () { sync(null, null); }, 0);
    bindTotalObserver();
    var drawer = document.getElementById('drawer-cart');
    if (drawer && window.MutationObserver) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var root = getRoot();
          if (root) place(root);
          hideBoxRows(lastCart, readConfig());
          bindTotalObserver();
        }, 100);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();